import React, { forwardRef } from 'react'
import { useTranslation } from 'i18n'
import Plus from 'images/inline/ugc/plus.svg'
import Minus from 'images/inline/ugc/minus.svg'
import Rotate from 'images/inline/ugc/rotate.svg'
import RotateLeft from 'images/inline/ugc/rotate-left.svg'
import Camera from 'images/inline/ugc/camera.svg'
import { useImageProcessing } from '../hooks/useImageProcessing'
import ControlButton from './ControlButton'

const ImageCanvasZone = forwardRef((props, ref) => {
  const { t } = useTranslation('ugcPhotoUpload')
  const { overlayImg, activeImg, onChangePhoto } = props
  const {
    handleMouseDown,
    handleMouseUp,
    handleMouseMove,
    zoomPhotoIn,
    zoomPhotoOut,
    rotateRight,
    rotateLeft,
    changePhoto,
    canvasRef,
  } = useImageProcessing({
    overlayImg,
    activeImg,
    onChangePhoto,
    parentRef: ref,
  })

  return (
    <>
      <div className="fabric-control-container">
        <ControlButton
          className="plus"
          action={zoomPhotoIn}
          title={t('controls.zoomIn')}
          icon={<Plus />}
        />
        <ControlButton
          className="minus"
          action={zoomPhotoOut}
          title={t('controls.zoomOut')}
          icon={<Minus />}
        />
        <ControlButton
          className="rotate"
          action={rotateRight}
          title={t('controls.rotateRight')}
          icon={<Rotate />}
        />
        <ControlButton
          className="rotate"
          action={rotateLeft}
          title={t('controls.rotateLeft')}
          icon={<RotateLeft />}
        />
        <ControlButton
          className="change-photo"
          action={changePhoto}
          title={t('controls.changePhoto')}
          icon={<Camera />}
        />
      </div>
      <div className={`fabric-canvas-column`}>
        <div className={`fabric-error`}>{}</div>
        <div className="fabric-canvas-wrapper">
          <canvas
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            ref={canvasRef}
            id="c"
          ></canvas>
        </div>
      </div>
    </>
  )
})

export default ImageCanvasZone
